import './PuxNumbersContainer.scss'

import React, { FunctionComponent } from 'react'

import PuxNumber, { PuxNumberType } from './PuxNumber'

export interface PuxNumbersContainerType {
  displayText: string
  numbersContainerShowProgress: boolean
  numberRadius: number
  numberStroke: number
  puxNumbersContainerItems: {
    contentItems: [PuxNumberType]
  }
  numbersContainerSelect: {
    cultureContentItems: [PuxNumberType]
  }
}

const PuxNumbersContainer: FunctionComponent<PuxNumbersContainerType> = (
  props
) => {
  return (
    <div className='NumbersContainer '>
      <div
        className={`NumbersContainer-grid`}
      >
        {props.puxNumbersContainerItems?.contentItems?.map((item) => (
          <PuxNumber
            {...item}
            numberShowProgress={props.numbersContainerShowProgress}
            numberRadius={67.5}
            numberStroke={8}
            key={item.contentItemId}
          />
        ))}
        {props.numbersContainerSelect?.cultureContentItems?.map((item) => (
          <PuxNumber
            {...item}
            numberShowProgress={props.numbersContainerShowProgress}
            numberRadius={67.5}
            numberStroke={8}
            key={item.contentItemId}
          />
        ))}
      </div>
    </div>
  )
}

export default PuxNumbersContainer
